import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CopyForm from "./form";
interface CopyPageFolderModalProps {
  showCopyModal: boolean;
  closeModal: () => void;
  pageId?: number | string;
  folderItemId?: number | string;
  type?: string;
}

const CopyPageFolderModal: React.FC<CopyPageFolderModalProps> = ({
  showCopyModal,
  closeModal,
  pageId,
  folderItemId,
  type,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal show={showCopyModal} onHide={closeModal} centered>
        <Modal.Header closeButton className="border-0">
          <Modal.Title>{t("copyModal.title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-4 text-center px-3 text-gray">
            {t("copyModal.copyDescription")}
          </p>
          <CopyForm
            closeModal={closeModal}
            pageId={pageId}
            folderItemId={folderItemId}
            type={type}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CopyPageFolderModal;
